import { useEffect, useRef, useMemo } from "react";
import ThemePlaceholder from "./ThemePlaceholder";
import { Input } from "reactstrap";

export default function InputField({
  loading = false,
  children,
  type = "text",
  value,
  onChange,
  onBlur,
  invalid,
  ...props
}) {
  const textareaRef = useRef(null);

  // Auto resize for textarea
  const resizeTextarea = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  };

  useEffect(() => {
    if (type === "textarea") {
      resizeTextarea();
    }
  }, [value]);

  const formattedValue = useMemo(() => {
    if (!value) return value;
    try {
      const date = new Date(value);
      if (type === "date") return date.toLocaleDateString("en-CA");
      if (type === "datetime-local") {
        const pad = (n) => String(n).padStart(2, "0");
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
          date.getDate()
        )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
      }
      if (type === "time") {
        const pad = (n) => String(n).padStart(2, "0");
        return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
      }
    } catch {
      return value;
    }
    return value;
  }, [value, type]);

  if (loading) {
    return (
      <ThemePlaceholder
        style={{ height: type === "textarea" ? 80 : 30 }}
        className="mb-2"
      />
    );
  }

  return (
    <Input
      {...props}
      type={type}
      value={formattedValue}
      innerRef={type === "textarea" ? textareaRef : null}
      onInput={type === "textarea" ? resizeTextarea : props.onInput}
      onChange={onChange}   // <-- important
      onBlur={onBlur}       // <-- important for Formik
      invalid={invalid}     // <-- pass touched && !!errors from Formik
      style={type === "textarea" ? { overflow: "hidden", resize: "none" } : {}}
    >
      {children}
    </Input>
  );
}
